import { render, staticRenderFns } from "./threshold_dateColumn.vue?vue&type=template&id=68f8d49f&scoped=true&"
import script from "./threshold_dateColumn.vue?vue&type=script&lang=js&"
export * from "./threshold_dateColumn.vue?vue&type=script&lang=js&"
import style0 from "./threshold_dateColumn.vue?vue&type=style&index=0&id=68f8d49f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f8d49f",
  null
  
)

export default component.exports